(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealWhenVisible(el) {
      function show() {
        el.classList.add('is-revealed');
      }
      if (!('IntersectionObserver' in window)) {
        show();
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          show();
          observer.disconnect();
        }
      }, { rootMargin: '0px 0px -50px 0px' });
      observer.observe(el);
    }

    function initCollectionsListSliders(root) {
      root.querySelectorAll('.collections-list__wrapper').forEach(function (wrapperEl) {
        const swiperEl = wrapperEl.querySelector('.collections-list__grid.swiper');
        if (!swiperEl) return;
        if (!swiperEl.dataset.revealBound) {
          swiperEl.dataset.revealBound = 'true';
          revealWhenVisible(swiperEl);
        }
        if (swiperEl.swiper || typeof Swiper === 'undefined') return;
        const slidesDesktop = parseInt(swiperEl.dataset.slidesDesktop, 10) || 3;
        new Swiper(swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 18,
          loop: false,
          navigation: {
            nextEl: wrapperEl.querySelector('.swiper-button-next'),
            prevEl: wrapperEl.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            598: { slidesPerView: Math.min(slidesDesktop, 2) },
            993: { slidesPerView: slidesDesktop },
          },
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initCollectionsListSliders(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      initCollectionsListSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.contact__button').addEventListener('click', function () {
      let submitBtn = this,
          formData = new FormData();

      submitBtn.setAttribute('disabled', 'disabled');

      formData.set('type', 'contacts');

      formData.set('name', document.querySelector('input[name="name"]').value);

      formData.set('email', document.querySelector('input[name="email"]').value);

      formData.set('phone', document.querySelector('input[name="phone"]').value);

      formData.set('message', document.querySelector('textarea[name="message"]').value);

      formData.set(
        "lang",
        document.documentElement.getAttribute("lang")
      );

      fetch(`https://activecampaign.yourst.agency/active-campaign`, {
        method: "POST",
        body: formData,
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.success) {
            document.querySelector('.contact__message__success').style.display = 'block';

            document.querySelector('input[name="name"]').value = '';

            document.querySelector('input[name="email"]').value = '';

            document.querySelector('input[name="phone"]').value = '';

            document.querySelector('textarea[name="message"]').value = '';
          } else {
            document.querySelectorAll('.field-error').forEach(el => el.remove());

              Object.entries(data.message).forEach(([field, message]) => {
                const fieldEl = document.getElementById(field);
                if (fieldEl) {
                  const error = document.createElement('p');
                  error.className = 'field-error';
                  error.style.color = '#d62828';
                  error.textContent = Array.isArray(message) ? message[0] : message;
                  fieldEl.parentNode.insertAdjacentElement('afterend', error);
                }
            });
            
            if (document.querySelector('.field-error')) {
              document.querySelector('.field-error').scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }

          submitBtn.removeAttribute('disabled');
        });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function setState(trigger, open) {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.classList.toggle('is-closed', !open);
  }

  function initFaq(section) {
    if (section.dataset.faqReady === 'true') return;
    section.dataset.faqReady = 'true';

    const allowMultiple = section.dataset.allowMultiple === 'true';
    const triggers = Array.from(section.querySelectorAll('.faq-trigger'));

    function toggle(trigger) {
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      if (willOpen && !allowMultiple) {
        triggers.forEach((other) => {
          if (other !== trigger) setState(other, false);
        });
      }
      setState(trigger, willOpen);
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => toggle(trigger));
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle(trigger);
        }
      });
    });

    if (section.dataset.firstOpen === 'true' && triggers[0]) {
      setState(triggers[0], true);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init on section load, open the selected block
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', (event) => {
    const trigger = event.target.querySelector('.faq-trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.products-list__wrapper').forEach(function (wrapperEl) {
      const swiperEl = wrapperEl.querySelector('.products-list__grid');
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 24,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: wrapperEl.querySelector('.products-list__nav--next'),
          prevEl: wrapperEl.querySelector('.products-list__nav--prev'),
        },
        pagination: {
          el: wrapperEl.querySelector('.products-list__dots'),
          clickable: true,
        },
        breakpoints: {
          0: { slidesPerView: 1.5 },
          520: { slidesPerView: 1.8 },
          790: { slidesPerView: 2.5 },
          1197: { slidesPerView: 4 },
        },
        on: {
          init: function (swiper) {
            centerIfNeeded(swiper, slideCount);
          },
          resize: function (swiper) {
            centerIfNeeded(swiper, slideCount);
          },
        },
      });
    });
    function centerIfNeeded(swiper, slideCount) {
      const perView = Math.round(swiper.params.slidesPerView);
      const wrapper = swiper.wrapperEl;

      if (slideCount < perView) {
        wrapper.style.justifyContent = 'center';
      } else {
        wrapper.style.justifyContent = '';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.poducts-slider__products', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.poducts-slider .swiper-button-next',
        prevEl: '.poducts-slider .swiper-button-prev',
      },
      pagination: false,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const addToCart = document.querySelector('.product-add__to__cart');
    const stickyBar = document.querySelector('.sticky-add-to-cart');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('show');
          } else {
            stickyBar.classList.add('show');
          }
        });
      },
      {
        threshold: 0,
      }
    );

    observer.observe(addToCart);
  });

  } catch(e) { console.error(e); }
})();
})();
